module.exports = __webpack_public_path__ + "img/paci_en_1.f9743fa0.png";